(function() {
'use strict';

angular
    .module('TR')
    .controller('NotFound', NotFound);

function NotFound(basketService,
        analytics,
        broker,
        occupancyService,
        $scope,
        $location,
        $route,
        savedSearchService) {
    broker.publish('unblock');
    const cm = this;
    const type = {
        3: basketService.holidayBooking,
        2: basketService.hotelBooking,
        4: basketService.transferBooking
    };
    cm.area = $route.current.area;

    savedSearchService.getSavedSearches().then(function(searches) {
        cm.mostRecent = _.head(searches);
        if (cm.mostRecent) {
            cm.mostRecent.occupancyStr = occupancyService.getOccupancyString(cm.mostRecent.Rooms);
        }
    });

    cm.restore = function() {
        if (cm.mostRecent == null) {
            $location.path(`/${cm.area}`);
        } else {
            $scope.$emit('block', {
                title: null,
                loadingScreenStyle: 'default-notFoundCtrl'
            });
            savedSearchService.restoreSearch(cm.mostRecent).then(function() {
                basketService.startWorkflow(type[cm.mostRecent.SearchType]);
                analytics.trackEvent({ label: 'rescued from trip 404' });
            });
        }
    };
}
})();
